import React from 'react';
import DeveloperSection from '../components/DeveloperSection';

const Developer = () => {
    return (
        <div className="developer-page">
            <DeveloperSection />
        </div>
    );
};

export default Developer;
